import React from 'react';
import { motion } from 'framer-motion';
interface BonusCardProps {
  number: number;
  title: string;
  description: string;
  imageUrl: string;
  delay?: number;
}
export function BonusCard({
  number,
  title,
  description,
  imageUrl,
  delay = 0
}: BonusCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white rounded-2xl overflow-hidden shadow-xl border border-orange-100 flex flex-col md:flex-row h-full" data-id="element-2">
      <div className="md:w-2/5 relative h-64 md:h-auto overflow-hidden bg-orange-50" data-id="element-3">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover object-center transform hover:scale-105 transition-transform duration-700" data-id="element-4" />
        <div className="absolute top-4 left-4 bg-yellow-400 text-yellow-900 font-bold px-3 py-1 rounded-full text-sm shadow-md" data-id="element-5">
          BONUS #{number}
        </div>
      </div>
      <div className="p-6 md:p-8 md:w-3/5 flex flex-col justify-center" data-id="element-6">
        <h3 className="text-2xl font-bold text-slate-800 mb-3" data-id="element-7">{title}</h3>
        <p className="text-slate-600 leading-relaxed" data-id="element-8">{description}</p>
      </div>
    </motion.div>;
}